<!-- Subscription Dialog -->
<div class="subscription-overlay">
  <div class="subscription-modal">
    <div *ngIf="processing" class="processing-container"><div class="dots" aria-hidden="true"><span></span><span></span><span></span></div></div>
    <div class="subscription-icon">
      <span class="material-symbols-outlined">notifications</span>
    </div>
    <h2>Enable Notifications</h2>
    <p>Stay connected with instant message notifications even when the chat is closed.</p>
    <button (click)="onSubscribe()" class="subscription-subscribe-btn">Subscribe to Notifications</button>
    <button (click)="onSkip()" class="subscription-skip-btn">Skip for now</button>
  </div>
</div>